import styled from 'styled-components';

export const _FieldDescription = styled.p`
  font-size: 1em;
  font-family: ${(props) => props.theme.fontFamilyPrimary};
  margin-top: 0;
  color: ${(props) => props.theme.input};
`;
